var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "VISA_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".VISA_svg__st5{fill-rule:evenodd;clip-rule:evenodd;fill:#1334cb}")), /*#__PURE__*/React.createElement("path", {
    d: "M38 24H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h36c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.2c0 1.4 1.2 2.2 2.2 2.6 1 .5 1.3.8 1.3 1.2 0 .6-.8.9-1.5.9-1.2 0-2-.3-2.5-.6l-.4 2.1c.6.3 1.7.5 2.8.5 2.6 0 4.3-1.3 4.3-3.3 0-2.5-3.5-2.7-3.5-3.8 0-.3.3-.7 1.1-.8.4 0 1.3-.1 2.4.4l.4-2c-.7-.2-1.4-.4-2.4-.4-2.4 0-4.2 1.3-4.2 3.2M33.4 7.2h-2.1c-.5 0-.9.3-1.1.7l-3.7 8.9h2.6l.5-1.4h3.2l.3 1.4h2.3zm-3.1 6.2 1.3-3.6.8 3.6zM17.4 7.2l-2.1 9.6h2.5l2.1-9.6zM13.7 7.2l-2.6 6.5-1-5.6c-.1-.6-.6-1-1.1-1H4.7l-.1.4c.9.2 1.9.5 2.5.8.4.2.5.4.6.8l2 7.7h2.6l4-9.6z",
    className: "VISA_svg__st5"
  })));
};
export default SvgVisa;